<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container content text-center" :style="{width: width, height: height}">
                    <a class="close-button" @click="$emit('close')"></a>
                    <div class="modal-header">
                        <h2 v-html="header"></h2>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            <div :html="body"></div>
                        </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer" v-if="buttonText.length">
                            <button-el @click.native="$emit('submit')" :button-text="buttonText" :button-class="buttonClass"></button-el>
                        </slot>
                        <div v-html="footer" class="footer-content"></div>
                        <div class="footer-content"  v-if="loginFooter">
                            <login-footer v-on:forget="$emit('forget')" v-on:register="$emit('register')"></login-footer>
                        </div>
                        <div class="footer-content"  v-if="registerFooter">
                            <register-footer v-on:tologin="$emit('tologin')"></register-footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    import Inputmask from 'inputmask'
    import ButtonEl from './elements/ButtonEl.vue'
    import LoginFooter from './elements/LoginModalFooter.vue'
    import RegisterFooter from './elements/RegisterModalFooter.vue'

    export default {
        props: ['width', 'height', 'header', 'body', 'footer', 'showModal', 'buttonText', 'buttonClass', 'loginFooter', 'registerFooter'],
        components: {
            ButtonEl,
            Inputmask,
            LoginFooter,
            RegisterFooter
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    h2 {
        font-weight: 900;
    }

    p {
        font-size: 17px;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        /*width: 300px;*/
        margin: 0 auto;
        padding: 108px 0;
        background-color: #f5f5f5;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
    }

    .close-button {
        position: absolute;
        display: block;
        right: 28px;
        top: 28px;
        background: url('../assets/images/close.svg') no-repeat;
        background-size: contain;
        width: 14px;
        height: 14px;
        cursor: pointer;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    @media screen and (max-width: 992px) {
        .modal-container {
            width: auto !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Modal.vue